import { AxiosResponse } from 'axios';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { ICreateStoreRequest, IApiGetDemoDataParam, IApiGetListStoresParam, IStore, IApiGetListScreensInStoreParam, ITimezone, IDetailStore, IApiGetMediaInStoreParam } from '../interfaces/api';
import { call, delay, put, takeLatest, select } from 'redux-saga/effects';
import { RootState } from 'store';
import { ISagaFunc } from 'services/actionConfigs';
import { PaginationResponse } from 'services/commonTypes';
import { IResponseData, getMessageError } from 'services/response';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import actions from './actions';
import apis from './apis';
import playlistApis from 'modules/playlist/services/apis';
import { IPlaylist } from 'modules/playlist/interfaces/api';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  }
};

const createStore: ISagaFunc<ICreateStoreRequest> = function* ({ payload }) {
  setPageLoading(true);
  try {
    const resData: IResponseData<boolean> = yield call(apis.createStore, payload);
    if (resData?.data?.data) {
      yield put(actions.createStore.success(resData.data.data));
      const params: IApiGetListStoresParam =
        (yield select((state: RootState) => state.store?.storeListParams)) || { page: 1, size: 10 };
      yield put(actions.getListStores.fetch(params));
      toast.success('Store created successfully');
    }
  } catch (error) {
    const message = getMessageError(error);
    toast.error(message);
    yield put(actions.createStore.fail({ message }));
  } finally {
    setPageLoading(false);
  }
};

const getListStores: ISagaFunc<IApiGetListStoresParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    delay(200);
    const resData: IResponseData<PaginationResponse<IStore>> = yield call(apis.getListStores, payload);
    if (resData?.data?.data) {
      yield put(actions.getListStores.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListStores.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const setListStoresParams: ISagaFunc<IApiGetListStoresParam> = function* ({ payload }) {
  yield put(actions.getListStores.fetch(payload));
};

const getListScreensInStore: ISagaFunc<IApiGetListScreensInStoreParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    delay(200);
    const resData: IResponseData<PaginationResponse<IScreen>> = yield call(apis.getListScreensInStore, payload);
    if (resData?.data?.data) {
      yield put(actions.getListScreensInStore.success(resData.data.data));
      yield put(actions.setScreenListInStoreParams(payload));
    }
  } catch (error) {
    yield put(actions.getListScreensInStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const getListTimezones: ISagaFunc<void> = function* () {
  try {
    const resData: IResponseData<ITimezone[]> = yield call(apis.getListTimezones);
    if (resData?.data?.data) {
      yield put(actions.getListTimezones.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListTimezones.fail({}));
  }
};

const getAllStores: ISagaFunc<void> = function* () {
  try {
    const resData: IResponseData<PaginationResponse<IStore>> = yield call(apis.getAllStores);
    if (resData?.data?.data) {
      yield put(actions.getAllStores.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getAllStores.fail({}));
  }
};

const getDetailStore: ISagaFunc<string> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<IDetailStore> = yield call(apis.detailStore, payload);
    if (resData?.data?.data) {
      yield put(actions.getDetailStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDetailStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const getAllPlaylistsInStore: ISagaFunc<IApiGetListScreensInStoreParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<PaginationResponse<IPlaylist>> = yield call(playlistApis.getListPlaylists, payload);
    if (resData?.data?.data) {
      yield put(actions.getAllPlaylistsInStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getAllPlaylistsInStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const getPlaylistsInStore: ISagaFunc<IApiGetListScreensInStoreParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<PaginationResponse<IPlaylist>> = yield call(playlistApis.getListPlaylists, payload);
    if (resData?.data?.data) {
      yield put(actions.getPlaylistsInStore.success(resData.data.data));
      console.log('payload12', payload);
      yield put(actions.setPlaylistsInStoreParams(payload));
    }
  } catch (error) {
    yield put(actions.getPlaylistsInStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const getMediaInStore: ISagaFunc<IApiGetMediaInStoreParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<PaginationResponse<IPlaylist>> = yield call(apis.getMediaInStore, payload);
    if (resData?.data?.data) {
      yield put(actions.getMediaInStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getMediaInStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const getSummaryStore: ISagaFunc<string> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<IDetailStore> = yield call(apis.getSummaryStore, payload);
    if (resData?.data?.data) {
      yield put(actions.getSummaryStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getSummaryStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

export default function* storeServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListStores.fetch, getListStores);
  yield takeLatest(actions.setListStoresParams, setListStoresParams);
  yield takeLatest(actions.createStore.fetch, createStore);
  yield takeLatest(actions.getListScreensInStore.fetch, getListScreensInStore);
  yield takeLatest(actions.getListTimezones.fetch, getListTimezones);
  yield takeLatest(actions.getAllStores.fetch, getAllStores);
  yield takeLatest(actions.getDetailStore.fetch, getDetailStore);
  yield takeLatest(actions.getAllPlaylistsInStore.fetch, getAllPlaylistsInStore);
  yield takeLatest(actions.getPlaylistsInStore.fetch, getPlaylistsInStore);
  yield takeLatest(actions.getMediaInStore.fetch, getMediaInStore);
  yield takeLatest(actions.getSummaryStore.fetch, getSummaryStore);
}
